import { render } from "./BigMenu.vue?vue&type=template&id=8f753a76&scoped=true"
import script from "./BigMenu.vue?vue&type=script&lang=js"
export * from "./BigMenu.vue?vue&type=script&lang=js"

import "./BigMenu.vue?vue&type=style&index=0&id=8f753a76&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f753a76"]])

export default __exports__